import gql from 'graphql-tag'

export const PREFERRED_LANGUAGE_QUERY = gql`
    query getPreferredLanguage($candidates: [LanguageCode!]!) {
        myPreferredLanguage(candidates: $candidates)
    }
`
